/* BIOMPLEX · Bewegung auf der Produktseite · Produktseiten-Chat · Fassung 4 vom 31.10.2026, 23:15: Einblende-Effekte aus (siehe Zeile reduce) · vorher Fassung 3 vom 31.10.2026 · siehe assets/bx-bewegung.css */
(function(){
  var reduce=true; /* 31.10.2026, 23:15: Einblende-Effekte aus (Entscheidung Dominik 23:03: Einblenden, Bild-Zoom, Punkte und Balken nacheinander wirken nicht harmonisch). Alles steht sofort da; die NRV-Balken in Stufe 3 bleiben als feste Linie. Zurück: diese Zeile durch die Abfrage prefers-reduced-motion ersetzen (Sicherung assets/bx-sicherung-bewegung-js-vor-aus-2026-10-31.js.txt). */
  var hasIO='IntersectionObserver' in window;
  var GROUPS=[
    ['.bxu',['.bxu-eye','.bxu-h','.bxu-lead','.bxu-glass > *']],
    ['.bxi',['.bxi-pic','.bxi-main > *']],
    ['.bx4p',['.bx4p-kopf > *','.bx4p-list > *']],
    ['.bx5e',['.bx5e-kopf > *','.bx5e-pic','.bx5e-plan','.bx5e-list > *']],
    ['.bxs',['.bxs-head > *','.bxs-acc > *','.bxs-cards > *']],
    ['.bxf-sec',['.bxf-end > *','.bxf-promise > *']],
    ['.bxpz',['.bxpz-kopf > *','.bxpz-item']]
  ];
  var ZOOM='.bxu-img, .bx5e-img, .bxi-pic img, .bxpz-pic img, .bxs-card img';
  var io=null;
  function obs(){
    if(io)return io;
    io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;var t=e.target;if(t.classList.contains('bx-rv'))t.classList.add('bx-rv-on');if(t.classList.contains('bx-zm'))t.classList.add('bx-zm-on');io.unobserve(t)})},{rootMargin:'0px 0px -6% 0px',threshold:.01});
    return io;
  }
  function below(el){return el.getBoundingClientRect().top>(window.innerHeight||800)*0.96}
  function reveal(scope){
    if(reduce||!hasIO)return;
    scope=scope||document;
    GROUPS.forEach(function(g){
      Array.prototype.forEach.call(scope.querySelectorAll(g[0]),function(sec){
        if(sec.dataset.bxRv)return;sec.dataset.bxRv='1';
        var n=0;
        g[1].forEach(function(s){Array.prototype.forEach.call(sec.querySelectorAll(s),function(el){
          if(el.classList.contains('bx-rv')||!below(el))return;
          el.style.setProperty('--bx-o',Math.min(n,6));n++;
          el.classList.add('bx-rv');obs().observe(el);
        })});
        Array.prototype.forEach.call(sec.querySelectorAll(ZOOM),function(img){
          if(img.classList.contains('bx-zm')||!below(img))return;
          img.classList.add('bx-zm');obs().observe(img);
        });
      });
    });
  }
  function vids(){
    Array.prototype.forEach.call(document.querySelectorAll('video.bxu-vid'),function(v){
      v.setAttribute('aria-hidden','true');v.muted=true;
      if(reduce){v.removeAttribute('autoplay');try{v.pause()}catch(e){}return}
      if(!hasIO)return;
      new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){})}else{v.pause()}})},{threshold:.15}).observe(v);
    });
  }
  function dots(){
    if(reduce||!hasIO)return;
    Array.prototype.forEach.call(document.querySelectorAll('.bx5e-woche'),function(w){
      if(w.getBoundingClientRect().top<(window.innerHeight||800)*0.85)return;
      Array.prototype.forEach.call(w.children,function(li,i){li.style.setProperty('--bx-d',i)});
      w.classList.add('bx-dots-pre');
      var o=new IntersectionObserver(function(es){if(es[0].isIntersecting){w.classList.add('bx-dots-on');o.disconnect()}},{rootMargin:'0px 0px -20% 0px'});
      o.observe(w);
    });
  }
  function sweep(){
    var h=window.innerHeight||800;
    Array.prototype.forEach.call(document.querySelectorAll('.bx-rv:not(.bx-rv-on), .bx-zm:not(.bx-zm-on)'),function(el){
      if(el.getBoundingClientRect().top<h){if(el.classList.contains('bx-rv'))el.classList.add('bx-rv-on');if(el.classList.contains('bx-zm'))el.classList.add('bx-zm-on');if(io)io.unobserve(el)}
    });
  }
  var sw=null;window.addEventListener('scroll',function(){if(sw)return;sw=setTimeout(function(){sw=null;sweep()},120)},{passive:true});
  function nrv(){
    Array.prototype.forEach.call(document.querySelectorAll('.bxi-tab'),function(tab){
      var rows=tab.querySelectorAll('.bxi-r:not(.bxi-r--kopf)'),k=0;
      Array.prototype.forEach.call(rows,function(r){
        var c=r.querySelector('.bxi-v');if(!c||c.querySelector('.bx-nrv'))return;
        var m=(c.textContent||'').replace(/\./g,'').replace(',','.').match(/(\d+(?:\.\d+)?)\s*%/);if(!m)return;
        var v=Math.min(100,parseFloat(m[1]));if(!(v>0))return;
        var s=document.createElement('span');s.className='bx-nrv';s.setAttribute('aria-hidden','true');var i=document.createElement('i');i.style.setProperty('--w',v+'%');s.appendChild(i);c.appendChild(s);
        r.style.setProperty('--bx-r',Math.min(k,12));k++;
      });
      if(!k||reduce||!hasIO)return;
      if(tab.getBoundingClientRect().top<(window.innerHeight||800)*0.9)return;
      tab.classList.add('bx-nrv-pre');
      var o2=new IntersectionObserver(function(es){if(es[0].isIntersecting){tab.classList.add('bx-nrv-on');o2.disconnect()}},{rootMargin:'0px 0px -12% 0px'});o2.observe(tab);
    });
  }
  function glass(){
    if(reduce||!hasIO)return;
    Array.prototype.forEach.call(document.querySelectorAll('.bxu-glass'),function(g){
      if(g.getBoundingClientRect().top<(window.innerHeight||800)*0.9)return;
      g.classList.add('bx-gl-pre');
      var o3=new IntersectionObserver(function(es){if(es[0].isIntersecting){g.classList.add('bx-gl-on');o3.disconnect()}},{rootMargin:'0px 0px -10% 0px'});o3.observe(g);
    });
  }
  function sweep2(){var h=window.innerHeight||800;Array.prototype.forEach.call(document.querySelectorAll('.bxi-tab.bx-nrv-pre:not(.bx-nrv-on)'),function(t){if(t.getBoundingClientRect().top<h)t.classList.add('bx-nrv-on')});Array.prototype.forEach.call(document.querySelectorAll('.bxu-glass.bx-gl-pre:not(.bx-gl-on)'),function(g){if(g.getBoundingClientRect().top<h)g.classList.add('bx-gl-on')})}
  window.addEventListener('scroll',function(){setTimeout(sweep2,150)},{passive:true});
  window.bxReveal=reveal;
  function go(){vids();reveal(document);dots();nrv();glass();
    var p=document.querySelector('[data-bxpz]');
    if(p&&'MutationObserver' in window){var mo=new MutationObserver(function(){if(p.querySelector('.bxpz-item')){p.removeAttribute('data-bx-rv');delete p.dataset.bxRv;reveal(p.parentNode||document);mo.disconnect()}});mo.observe(p,{childList:true,subtree:true})}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();
